import { call, put, takeLatest } from "redux-saga/effects";
import {
  IMauEmail,
  IMauEmailBien,
  IMauEmailGuiRequest,
  IMauEmailGuiResult,
  IMauEmailLichSuRequest,
  IMauEmailLichSuResult,
  IMauEmailLocRequest,
  IMauEmailLocResult,
  IMauEmailSaveRequest,
  IMauEmailSelectRequest,
  mauEmailApi,
} from "../../../api/thiet-lap/mauEmailApi";
import { NotifyHelper } from "../../../helpers/toast";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eMauEmailActionIds,
  IMauEmailActionTypes,
} from "../../action-types/thiet-lap/IMauEmailActions";
import { rootActions } from "../../actions/rootActions";

const mainAction = rootActions.thietLap.mauEmail;

export function* mauEmailSaga(): any {
  yield takeLatest(eMauEmailActionIds.MAU_LOAD_START, loadMauWorker);
  yield takeLatest(eMauEmailActionIds.MAU_SAVE_START, saveMauWorker);
  yield takeLatest(eMauEmailActionIds.MAU_DELETE_START, deleteMauWorker);
  yield takeLatest(eMauEmailActionIds.BIEN_LOAD_START, loadBienWorker);
  yield takeLatest(eMauEmailActionIds.SMTP_LOAD_START, loadSmtpWorker);
  yield takeLatest(eMauEmailActionIds.LOC_START, locWorker);
  yield takeLatest(eMauEmailActionIds.GUI_START, guiWorker);
  yield takeLatest(eMauEmailActionIds.XEM_TRUOC_START, xemTruocWorker);
  yield takeLatest(eMauEmailActionIds.LICHSU_LOAD_START, loadLichSuWorker);
}

function* loadMauWorker(action: IMauEmailActionTypes): any {
  const res: IBaseRespone = yield call(
    mauEmailApi.Select,
    action.payload as IMauEmailSelectRequest,
  );
  if (res.is_success) {
    yield put(mainAction.MAU_LOAD_SUCCESS((res.data as IMauEmail[]) ?? []));
  } else {
    yield put(mainAction.MAU_LOAD_ERROR(res.message ?? "Có lỗi"));
    NotifyHelper.Error(res.message ?? "Có lỗi");
  }
}

function* saveMauWorker(action: IMauEmailActionTypes): any {
  const res: IBaseRespone = yield call(
    mauEmailApi.Save,
    action.payload as IMauEmailSaveRequest,
  );
  if (res.is_success) {
    yield put(mainAction.MAU_SAVE_SUCCESS(""));
    NotifyHelper.Success("Đã lưu mẫu email");
  } else {
    yield put(mainAction.MAU_SAVE_ERROR(res.message ?? "Có lỗi"));
    NotifyHelper.Error(res.message ?? "Có lỗi");
  }
}

function* deleteMauWorker(action: IMauEmailActionTypes): any {
  const res: IBaseRespone = yield call(mauEmailApi.Delete, action.payload as number);
  if (res.is_success) {
    yield put(mainAction.MAU_DELETE_SUCCESS(""));
    NotifyHelper.Success("Đã xóa mẫu email");
  } else {
    yield put(mainAction.MAU_DELETE_ERROR(res.message ?? "Có lỗi"));
    NotifyHelper.Error(res.message ?? "Có lỗi");
  }
}

function* loadBienWorker(): any {
  const res: IBaseRespone = yield call(mauEmailApi.DanhSachBien);
  if (res.is_success) {
    yield put(mainAction.BIEN_LOAD_SUCCESS((res.data as IMauEmailBien[]) ?? []));
  } else {
    // Không có danh sách chỗ điền thì vẫn khai mẫu được (gõ tay) -> không báo lỗi ồn ào.
    yield put(mainAction.BIEN_LOAD_ERROR(res.message ?? "Có lỗi"));
  }
}

function* loadSmtpWorker(): any {
  const res: IBaseRespone = yield call(mauEmailApi.CoCauHinhSmtp);
  yield put(mainAction.SMTP_LOAD_SUCCESS(res.is_success ? !!res.data : false));
}

function* locWorker(action: IMauEmailActionTypes): any {
  // Lọc công nợ cả trường có thể mất vài chục giây (thủ tục công nợ của màn Tổng hợp) ->
  // phủ lớp "đang xử lý" để không ai tưởng màn hình treo.
  yield put(rootActions.common.layout.SHOW_HIDE_LOADING_PAGE(true));
  try {
    const res: IBaseRespone = yield call(
      mauEmailApi.LocSinhVien,
      action.payload as IMauEmailLocRequest,
    );
    if (res.is_success) {
      yield put(mainAction.LOC_SUCCESS(res.data as IMauEmailLocResult));
    } else {
      yield put(mainAction.LOC_ERROR(res.message ?? "Có lỗi"));
      NotifyHelper.Error(res.message ?? "Có lỗi");
    }
  } finally {
    yield put(rootActions.common.layout.SHOW_HIDE_LOADING_PAGE(false));
  }
}

function* guiWorker(action: IMauEmailActionTypes): any {
  yield put(rootActions.common.layout.SHOW_HIDE_LOADING_PAGE(true));
  try {
    const res: IBaseRespone = yield call(
      mauEmailApi.Gui,
      action.payload as IMauEmailGuiRequest,
    );
    if (res.is_success) {
      const kq = res.data as IMauEmailGuiResult;
      yield put(mainAction.GUI_SUCCESS(kq));
      NotifyHelper.Success(
        `Đã đưa ${kq?.so_gui ?? 0} email vào hàng đợi gửi` +
          ((kq?.so_bo_qua ?? 0) > 0 ? `, bỏ qua ${kq.so_bo_qua} sinh viên` : ""),
      );
      // Lý do bỏ qua hiện riêng: cán bộ cần biết em nào không nhận được và vì sao.
      (kq?.bo_quas ?? []).slice(0, 5).forEach((m) => NotifyHelper.Error(m));
    } else {
      yield put(mainAction.GUI_ERROR(res.message ?? "Có lỗi"));
      NotifyHelper.Error(res.message ?? "Có lỗi");
    }
  } finally {
    yield put(rootActions.common.layout.SHOW_HIDE_LOADING_PAGE(false));
  }
}

function* xemTruocWorker(action: IMauEmailActionTypes): any {
  // Xem trước cũng tính lại công nợ ở máy chủ (để số tiền trong email là số thật) nên có thể
  // mất vài giây — phủ lớp "đang xử lý" như khi lọc.
  yield put(rootActions.common.layout.SHOW_HIDE_LOADING_PAGE(true));
  try {
    const res: IBaseRespone = yield call(mauEmailApi.Gui, {
      ...(action.payload as IMauEmailGuiRequest),
      chi_xem_truoc: true,
    });
    if (res.is_success) {
      const kq = res.data as IMauEmailGuiResult;
      if (kq?.xem_truoc) {
        yield put(mainAction.XEM_TRUOC_SUCCESS(kq.xem_truoc));
      } else {
        yield put(mainAction.XEM_TRUOC_ERROR("Không dựng được bản xem trước"));
        NotifyHelper.Error("Không dựng được bản xem trước");
      }
    } else {
      yield put(mainAction.XEM_TRUOC_ERROR(res.message ?? "Có lỗi"));
      NotifyHelper.Error(res.message ?? "Có lỗi");
    }
  } finally {
    yield put(rootActions.common.layout.SHOW_HIDE_LOADING_PAGE(false));
  }
}

function* loadLichSuWorker(action: IMauEmailActionTypes): any {
  const res: IBaseRespone = yield call(
    mauEmailApi.LichSu,
    action.payload as IMauEmailLichSuRequest,
  );
  if (res.is_success) {
    yield put(mainAction.LICHSU_LOAD_SUCCESS(res.data as IMauEmailLichSuResult));
  } else {
    yield put(mainAction.LICHSU_LOAD_ERROR(res.message ?? "Có lỗi"));
    NotifyHelper.Error(res.message ?? "Có lỗi");
  }
}
